module.exports = __webpack_public_path__ + "media/images/icons/prize-498d4a39902b80ca8011931d7e5fbe5e.svg";